import { useMemo, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import COURSE_QUERY from '../queries/COURSE_QUERY';

const useCourse =  ( courseId ) => {
    const [ fetchCourse, { loading, error, refetch } ] = useLazyQuery( COURSE_QUERY, { fetchPolicy: 'cache-and-network' } );

    const [ courseData, setCourseData ] = useState();

    function onFetchComplete( data ) {
        if ( data?.course?.node ) {
            setCourseData( {
                ...data.course.node,
                locales: data.course.node.locales.map( i => {
                    return {
                        locale: i.locale,
                        name: i.name === null ? '' : i.name,
                        description: i.description === null ? '' : i.description,
                    };
                } ),
                learningObjects: data.course.node.learningObjects?.edges?.map( e => e.node ).map( o => ( { name: o.locales.find( l => l.locale === 'en-US' )?.name, ...o } ) )
            } );
        } else {
            setCourseData( false );
        }
    }
    
    const loadCourse = async ( courseId ) => {
        const vars = {
            variables: {
                courseID: courseId
            },
            fetchPolicy: 'network-only'
        };

        const result = await fetchCourse( vars );
        onFetchComplete( result?.data );
        return result;
    };

    // Apollo 3.8+ does not fire the hook's onCompleted on imperative refetch(),
    // so we consume the promise it resolves with and run onFetchComplete ourselves.
    const refetchCourse = async ( ...args ) => {
        const result = await refetch?.( ...args );
        onFetchComplete( result?.data );
        return result;
    };

    return useMemo( () => {
        return {
            loadCourse: loadCourse,
            courseData,
            courseError: error,
            courseLoading: loading,
            refetchCourse: refetchCourse,
        };
    }, [ fetchCourse, courseData, error, loading, refetch ] );
};

export default useCourse;
